
export const ACCEPT_TYPE = 'image/*';

export const REQUEST_STATUS__PENDING = 'pending';
export const REQUEST_STATUS__SUCCESS = 'success';
export const REQUEST_STATUS__ERROR = 'error';
export const REQUEST_STATUS__NULL = 'null';
